export class ProviderResponseModel {
    status: boolean;
    message: string;
    data: any;
    isUserConfirmationRequired: boolean;
}
